import { FaGithub, FaLinkedinIn } from 'react-icons/fa';
import { SiLeetcode } from 'react-icons/si';
import { Social } from '../types/Social.ts';

export const SocialData: Social[] = [
  { href: 'https://github.com/rahulgtst', Icon: FaGithub },
  { href: 'https://www.linkedin.com/in/rahulgtst', Icon: FaLinkedinIn },
  { href: 'https://leetcode.com/u/rahulgtst', Icon: SiLeetcode },
];